export default {"src":"/_next/static/media/zump_logo_primary.db747917.svg","height":240,"width":962,"blurWidth":0,"blurHeight":0};